import React from 'react';
import { Link } from 'react-router-dom';
import { translations } from '../utils/translations';

const Footer = ({ language = 'en' }) => {
  const currentYear = new Date().getFullYear();
  const t = translations[language];

  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* Footer Top */}
        <div className="footer-top">
          <div className="footer-brand">
            <img 
              src="/logo.png" 
              alt="Atelier - The art of living in Ibiza"
              className="footer-logo-image"
            />
            <p className="footer-tagline">{t.footer.tagline}</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>{t.footer.navigate}</h4>
              <Link to="/">{t.nav.home}</Link>
              <Link to="/about">{t.nav.about}</Link>
              <Link to="/contact">{t.nav.contact}</Link>
            </div>

            <div className="footer-column">
              <h4>{t.footer.contact}</h4>
              <span>Edificio Nueva Ibiza</span>
              <span>Carrer Gregal 8, Local 24</span>
              <span>07800 Eivissa, Spain</span>
              <span className="footer-phone">+34 659 170 057</span>
            </div>

            <div className="footer-column">
              <h4>{t.footer.services}</h4>
              <span>{t.services.realEstate.title}</span>
              <span>{t.services.rentals.title}</span>
              <span>{t.services.yacht.title}</span>
              <span>{t.services.aviation.title}</span>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <p>© {currentYear} {t.footer.copyright}</p>
            <div className="footer-legal-links">
              <Link to="/privacy">{t.footer.privacy}</Link>
              <Link to="/terms">{t.footer.terms}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
